import {memo} from 'react';
import {CountryShort} from "../types/Responses/CountriesResponse";
import {SystemLanguageInterface} from "../types/Responses/SystemResponse";
import {Language} from "../types/Responses/LanguagesResponse";

interface BrokerAvatarProps {
    country: CountryShort | SystemLanguageInterface | Language,
    withName?: boolean,
    className?: string,
}

const BrokerAvatar = ({country, className, withName = true}: BrokerAvatarProps) => {
    const flag = "flag" in country ? country.flag : ("code" in country ? country.code + '.png' : '');

    return <><img
        src={`${window.location.origin}/images/countries/${flag}`}
        className={`${className ?? 'h-3'} inline-block mr-2`}/>{withName ? country.name : ''}</>;
}

export default memo(BrokerAvatar);
